// Supervision email — file historique et trace de l'agent, sortis du Bureau AMO (W-1). Super admin seul.
import { useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";
import { Inbox, Workflow } from "lucide-react";

import EmailWorkerDashboard from "./EmailWorkerDashboard";
import AG04Dashboard from "./AG04Dashboard";

export default function SupervisionEmail() {
  let user = null;
  try { user = useAuth().user; } catch (e) { user = null; } // eslint-disable-line react-hooks/rules-of-hooks
  const estSuperAdmin = user?.role === "super_admin" || user?.is_super_admin === true;
  const [onglet, setOnglet] = useState("ag04");

  if (!estSuperAdmin) {
    return (
      <p data-testid="supervision-email-refus" style={{ color: "var(--oh-text-muted)" }}>
        Cet écran est réservé au super admin.
      </p>
    );
  }
  return (
    <div className="space-y-4" data-testid="supervision-email">
      <div>
        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 500, color: "var(--oh-text)" }}>Supervision email</h1>
        <p style={{ margin: 0, fontSize: 14, color: "var(--oh-text-muted)" }}>Vues techniques du traitement automatique de la boîte amo@</p>
      </div>
      <Tabs value={onglet} onValueChange={setOnglet}>
        <TabsList>
          <TabsTrigger value="ag04" data-testid="supervision-email-tab-ag04"><Workflow className="w-4 h-4 mr-1" aria-hidden="true" /> Trace de l'agent</TabsTrigger>
          <TabsTrigger value="pending" data-testid="supervision-email-tab-pending"><Inbox className="w-4 h-4 mr-1" aria-hidden="true" /> File historique</TabsTrigger>
        </TabsList>
        <TabsContent value="ag04" className="mt-4"><AG04Dashboard /></TabsContent>
        <TabsContent value="pending" className="mt-4"><EmailWorkerDashboard /></TabsContent>
      </Tabs>
    </div>
  );
}
